import { useState } from "react";

import DialogBox from "components/layout/DialogBox";
import FunctionalButton from "components/layout/FunctionalButton";
import AnimatedModal from "components/layout/motion/AnimatedModal";

import { logout } from "lib/orgServer/OrgServerClient";

import { ReactComponent as LogoutIcon } from "assets/svgs/navbar/Logout.svg";

const FleetLogoutButton = () => {
    const [confirming, setConfirming] = useState(false);

    const confirmLogout = () => {
        logout();
        window.location.reload();
    };

    return (
        <>
            <LogoutIcon
                className="w-5 cursor-pointer text-black60 hover:text-primary"
                onClick={() => setConfirming(true)}
            />
            <AnimatedModal visible={confirming} onClose={() => setConfirming(false)}>
                <DialogBox
                    embedded
                    description="Are you sure to logout?"
                    onClose={() => setConfirming(false)}
                    cancelButton={
                        <FunctionalButton
                            title="Cancel"
                            className="cancel-button"
                            onClick={() => setConfirming(false)}
                        />
                    }
                    confirmButton={
                        <FunctionalButton
                            title="Logout"
                            className="confirm-button"
                            onClick={confirmLogout}
                        />
                    }
                />
            </AnimatedModal>
        </>
    );
};

export default FleetLogoutButton;
